module.exports = __webpack_public_path__ + "gfx/PB-23.png";